import { call, put, takeLatest, select } from 'redux-saga/effects';

import { Message, messageBannerFunctions, MessageTypes } from '@nhl/nhl-react-ui/lib/MessageBanner';

import { commonMessages } from '~/utility/commonMessages';
import { fetchStatsData } from '~/utility/requests';
import { translate } from '~/utility/translator';

import { dataTableActionTypes, dataTableActionCreators } from '../dataTable';
import selectors from '../selectors';

// Our generator function to actually fetch data
export function* fetchData() {
    try {
        // `select` here is like calling a selector on the redux state, we're using `genDataUrl` on the state to get url
        const url = yield select(selectors.genDataUrl);

        // Now we're telling redux-saga to `fetchStatsData` with `url` as its arg
        const response = yield call(fetchStatsData, url);

        // Finally, `put` tells saga to dispatch `fetchDataSuccess` action with the data
        yield put(dataTableActionCreators.fetchDataSuccess(response));
    } catch (e) {
        const errorMessage = translate(commonMessages.misc.unknown);
        messageBannerFunctions.dispatchMessage(new Message(errorMessage, MessageTypes.ERROR));
        yield call(console.error, e);
    }
}

// This is similar to setting up an event listener
// We're listening for any FETCH_DATA_REQUEST and calling `fetchData`
// `takeLatest` is a way to say "if another REQUEST comes in before this one finishes, cancel the last one and restar"
export default function* watchFetchDataRequests() {
    yield takeLatest(dataTableActionTypes.FETCH_DATA_REQUEST, fetchData);
}
